/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PaginatedTimelineEntryReadList } from '../model/paginatedTimelineEntryReadList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ChildPortfolioChildTimelineService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * GET /children/{child_uuid}/timeline/
     * @param childUuid 
     * @param id A UUID string identifying this Záznam časové osy.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioTimelineDestroy(childUuid: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public childPortfolioTimelineDestroy(childUuid: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public childPortfolioTimelineDestroy(childUuid: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public childPortfolioTimelineDestroy(childUuid: string, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (childUuid === null || childUuid === undefined) {
            throw new Error('Required parameter childUuid was null or undefined when calling childPortfolioTimelineDestroy.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling childPortfolioTimelineDestroy.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/child-portfolio/${encodeURIComponent(String(childUuid))}/timeline/${encodeURIComponent(String(id))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * GET /children/{child_uuid}/timeline/
     * @param childUuid 
     * @param activity 
     * @param competenceCategory Více hodnot lze oddělit čárkami.
     * @param competencies 
     * @param created 
     * @param createdDate 
     * @param createdDateGte 
     * @param createdDateLte 
     * @param createdGte 
     * @param createdLte 
     * @param date 
     * @param dateDate 
     * @param dateDateGte 
     * @param dateDateLte 
     * @param dateGte 
     * @param dateLte 
     * @param hasFiles 
     * @param hasNote 
     * @param kind * &#x60;record_activity&#x60; - Záznam aktivita * &#x60;record_touch&#x60; - Záznam dotek * &#x60;skill&#x60; - Dovednost * &#x60;competence&#x60; - Kompetence * &#x60;literacy&#x60; - Gramotnost * &#x60;note&#x60; - Poznámka * &#x60;file&#x60; - Soubor * &#x60;other&#x60; - Jiné
     * @param limit Number of results to return per page.
     * @param literacies 
     * @param note 
     * @param noteIcontains 
     * @param offset The initial index from which to return the results.
     * @param ordering Which field to use when ordering the results.
     * @param skillArea Více hodnot lze oddělit čárkami.
     * @param skillSubarea Více hodnot lze oddělit čárkami.
     * @param skills 
     * @param teacher 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioTimelineList(childUuid: string, activity?: string, competenceCategory?: Array<string>, competencies?: Array<string>, created?: Date, createdDate?: string, createdDateGte?: string, createdDateLte?: string, createdGte?: Date, createdLte?: Date, date?: Date, dateDate?: string, dateDateGte?: string, dateDateLte?: string, dateGte?: Date, dateLte?: Date, hasFiles?: boolean, hasNote?: boolean, kind?: string, limit?: number, literacies?: Array<string>, note?: string, noteIcontains?: string, offset?: number, ordering?: string, skillArea?: Array<string>, skillSubarea?: Array<string>, skills?: Array<string>, teacher?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedTimelineEntryReadList>;
    public childPortfolioTimelineList(childUuid: string, activity?: string, competenceCategory?: Array<string>, competencies?: Array<string>, created?: Date, createdDate?: string, createdDateGte?: string, createdDateLte?: string, createdGte?: Date, createdLte?: Date, date?: Date, dateDate?: string, dateDateGte?: string, dateDateLte?: string, dateGte?: Date, dateLte?: Date, hasFiles?: boolean, hasNote?: boolean, kind?: string, limit?: number, literacies?: Array<string>, note?: string, noteIcontains?: string, offset?: number, ordering?: string, skillArea?: Array<string>, skillSubarea?: Array<string>, skills?: Array<string>, teacher?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedTimelineEntryReadList>>;
    public childPortfolioTimelineList(childUuid: string, activity?: string, competenceCategory?: Array<string>, competencies?: Array<string>, created?: Date, createdDate?: string, createdDateGte?: string, createdDateLte?: string, createdGte?: Date, createdLte?: Date, date?: Date, dateDate?: string, dateDateGte?: string, dateDateLte?: string, dateGte?: Date, dateLte?: Date, hasFiles?: boolean, hasNote?: boolean, kind?: string, limit?: number, literacies?: Array<string>, note?: string, noteIcontains?: string, offset?: number, ordering?: string, skillArea?: Array<string>, skillSubarea?: Array<string>, skills?: Array<string>, teacher?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedTimelineEntryReadList>>;
    public childPortfolioTimelineList(childUuid: string, activity?: string, competenceCategory?: Array<string>, competencies?: Array<string>, created?: Date, createdDate?: string, createdDateGte?: string, createdDateLte?: string, createdGte?: Date, createdLte?: Date, date?: Date, dateDate?: string, dateDateGte?: string, dateDateLte?: string, dateGte?: Date, dateLte?: Date, hasFiles?: boolean, hasNote?: boolean, kind?: string, limit?: number, literacies?: Array<string>, note?: string, noteIcontains?: string, offset?: number, ordering?: string, skillArea?: Array<string>, skillSubarea?: Array<string>, skills?: Array<string>, teacher?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (childUuid === null || childUuid === undefined) {
            throw new Error('Required parameter childUuid was null or undefined when calling childPortfolioTimelineList.');
        }





























        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (activity !== undefined && activity !== null) {
            queryParameters = queryParameters.set('activity', <any>activity);
        }
        if (competenceCategory) {
            queryParameters = queryParameters.set('competence_category', competenceCategory.join(COLLECTION_FORMATS['csv']));
        }
        if (competencies) {
            competencies.forEach((element) => {
                queryParameters = queryParameters.append('competencies', <any>element);
            })
        }
        if (created !== undefined && created !== null) {
            queryParameters = queryParameters.set('created', <any>created.toISOString());
        }
        if (createdDate !== undefined && createdDate !== null) {
            queryParameters = queryParameters.set('created__date', <any>createdDate);
        }
        if (createdDateGte !== undefined && createdDateGte !== null) {
            queryParameters = queryParameters.set('created__date__gte', <any>createdDateGte);
        }
        if (createdDateLte !== undefined && createdDateLte !== null) {
            queryParameters = queryParameters.set('created__date__lte', <any>createdDateLte);
        }
        if (createdGte !== undefined && createdGte !== null) {
            queryParameters = queryParameters.set('created__gte', <any>createdGte.toISOString());
        }
        if (createdLte !== undefined && createdLte !== null) {
            queryParameters = queryParameters.set('created__lte', <any>createdLte.toISOString());
        }
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', <any>date.toISOString());
        }
        if (dateDate !== undefined && dateDate !== null) {
            queryParameters = queryParameters.set('date__date', <any>dateDate);
        }
        if (dateDateGte !== undefined && dateDateGte !== null) {
            queryParameters = queryParameters.set('date__date__gte', <any>dateDateGte);
        }
        if (dateDateLte !== undefined && dateDateLte !== null) {
            queryParameters = queryParameters.set('date__date__lte', <any>dateDateLte);
        }
        if (dateGte !== undefined && dateGte !== null) {
            queryParameters = queryParameters.set('date__gte', <any>dateGte.toISOString());
        }
        if (dateLte !== undefined && dateLte !== null) {
            queryParameters = queryParameters.set('date__lte', <any>dateLte.toISOString());
        }
        if (hasFiles !== undefined && hasFiles !== null) {
            queryParameters = queryParameters.set('has_files', <any>hasFiles);
        }
        if (hasNote !== undefined && hasNote !== null) {
            queryParameters = queryParameters.set('has_note', <any>hasNote);
        }
        if (kind !== undefined && kind !== null) {
            queryParameters = queryParameters.set('kind', <any>kind);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (literacies) {
            literacies.forEach((element) => {
                queryParameters = queryParameters.append('literacies', <any>element);
            })
        }
        if (note !== undefined && note !== null) {
            queryParameters = queryParameters.set('note', <any>note);
        }
        if (noteIcontains !== undefined && noteIcontains !== null) {
            queryParameters = queryParameters.set('note__icontains', <any>noteIcontains);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (skillArea) {
            queryParameters = queryParameters.set('skill_area', skillArea.join(COLLECTION_FORMATS['csv']));
        }
        if (skillSubarea) {
            queryParameters = queryParameters.set('skill_subarea', skillSubarea.join(COLLECTION_FORMATS['csv']));
        }
        if (skills) {
            skills.forEach((element) => {
                queryParameters = queryParameters.append('skills', <any>element);
            })
        }
        if (teacher !== undefined && teacher !== null) {
            queryParameters = queryParameters.set('teacher', <any>teacher);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedTimelineEntryReadList>('get',`${this.basePath}/child-portfolio/${encodeURIComponent(String(childUuid))}/timeline/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
